export enum PaidOrganicFilterEnum {
    Organic = 0,
    Paid = 1,
}
